import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from '@/App';
import { AuthProvider } from '@/context/AuthContext';
import { CreditsProvider } from '@/context/CreditsContext';
import { AppThemeProvider } from '@/theme/ThemeProvider';
import { I18nProvider } from '@/i18n/I18nContext';

ReactDOM.createRoot(document.getElementById('root')!).render(
	<React.StrictMode>
		<I18nProvider>
			<AppThemeProvider>
				<BrowserRouter>
					<AuthProvider>
						<CreditsProvider>
							<App />
						</CreditsProvider>
					</AuthProvider>
				</BrowserRouter>
			</AppThemeProvider>
		</I18nProvider>
	</React.StrictMode>
);
